<div class="modal-header">

    <h4 *ngIf="(EmployeeTimeLogList$ | async) as list; else loading" class="modal-title">
        {{ list.length > 0 ? list[0].ikr + ': ' + medarbejder.init : 'Data ikke tilgængelig'}}
    </h4>

    <ng-template #loading>
    <p>Data is loading...</p>
    </ng-template>

    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-sm table-frame__body">
            <thead>
                <tr>
                    <th>Dato</th>
                    <th>IKR</th>
                    <th>Beskrivelse</th>
                    <th>Timer</th>
                </tr>
            </thead>

            <tbody>
            <ng-container  *ngFor="let viewModel of EmployeeTimeLogList$ | async;">
                <tr *ngFor="let vm of viewModel.employeeTimeLogViewModels">
                    <td>{{vm.dato | date:'dd-MM-yyyy'}}</td>
                    <td>{{vm.ikr}}</td>
                    <td>{{vm.beskrivelse}}</td>
                    <td>{{vm.timer | time}}</td>
                </tr>
                <tr class="border-top border-bottom">
                    <th>SubTotal</th>
                    <th></th>
                    <th></th>
                    <th>{{getTotal(viewModel) | time}}</th>
                </tr>
            </ng-container>
            </tbody>
            <tfoot>
                <tr class="border-top border-bottom">
                    <th>Total</th>
                    <th></th>
                    <th></th>
                    <th>{{getGrandTotal(EmployeeTimeLogList$ | async) | time}}</th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
